import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppBaseInfoVO } from '../Type/PackEntityAppBaseInfoVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询应用详情
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function detail(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityAppBaseInfoVO>
export function detail(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityAppBaseInfoVO extends { msg: unknown } ? PackEntityAppBaseInfoVO['msg'] : undefined>
export function detail(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/detail', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
